import { useAuthStore } from '@/stores/auth'
import { inject, toValue } from 'vue'
import { log } from '@/services/log'

const NAME = 'User Activity Guard'

export default async function ({ path, meta: { storeFn } }) {
  const authStore = useAuthStore()
  const user = authStore.user
  const store = storeFn == null ? null : storeFn()
  const observer = inject('userActivityObserver')
  const moduleName = store?.form?.item != null ? store?.formModuleName : store?.listingModuleName
  const activityName = store?.form?.item != null ? store?.formActivityName : store?.listingActivityName

  const dexie = inject('dexie')
  if (observer == null) {
    log(NAME, ': No observer inject available', path)
    return true
  }

  if (dexie == null) {
    log(NAME, ': No dexie inject available', path)
    return true
  }

  const act = toValue(observer.activity)
  if (act != null) {
    log(NAME, ': closing existing activity', act, 'before navigating to', path)
    observer.closeUserActivity(dexie)
  }
  if (store != null && moduleName?.length > 0 && activityName?.length > 0) {
    log(NAME, ': creating activity', act, 'before navigating to', path, moduleName, activityName)
    observer.createActivity(moduleName, activityName, user?.externalId)
  } else if (store == null) log(NAME, ': No store configured in meta')
  else log(NAME, ': Module name', moduleName, ', Activity name', activityName, 'must be non-empty for user activity')
  return true
}
